module.exports = __webpack_public_path__ + "static/media/unigrams_frequency.0b7160d4.zip";